<template>
  <div
    v-if="!success"
    v-tooltip="{ text }"
    class="pb-item-icon pb-item-report-icon"
  >
    <UiIcon
      :icon="icon"
      :color="level"
      size="default"
    />
  </div>
</template>

<script setup>
import { toRef } from 'vue'
import vTooltip from '@nicolaudie-group/ng-ui-kit/directives/vTooltip'
import UiIcon from '@nicolaudie-group/ng-ui-kit/components/UiIcon/UiIcon.vue'
import useReportBadge from '@/composables/useReportBadge'

const props = defineProps({
  report: {
    type: Object,
    default: () => ({
      infos: [],
      warnings: [],
      errors: [],
    }),
  },
})

const {
  success,
  text,
  icon,
  level,
} = useReportBadge(toRef(props, 'report'))

</script>

<style lang="scss" src="./ItemIcon.scss" />
